<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item ">
          <router-link to="/">Home</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Editando reglas</li>
      </ol>
    </nav>
    <div class="container">
      <div v-if="successMessage" class="alert alert-success" role="alert">
        {{ successMessage }}
      </div>
      <div v-if="errorMessages.length" class="alert alert-danger" role="alert">
        <p v-for="message in errorMessages">{{ message }}</p>
      </div>
      <div style="display:none">{{ rulesSet }}</div>
      <h1 class="text-center">Edici&oacute;n de reglas aplicadas a templates del SCR</h1>
      <form>
        <section>
          <!-- Datos principales -->
          <h2>Datos principales</h2>
          <div class="form-group">
            <!-- Template -->
            <label for="template_id" class="font-weight-bold">Template</label> (Obligatorio)
            <template-selector
              v-if="rulesSet.templateId !== undefined"
              @error="onComponentError"
              @update="onTemplateUpdate"
              :selected-value="rulesSet.templateId"
            />
            <p>Especifica el template que se va a utilizar en el SCR si se cumplen todas las reglas especificadas.
              Los siguientes templates no deben usarse para procesos de reservas:
              <b>Payment</b>, <b>Purchase modification</b>, <b>Coupon first without payment</b></p>
          </div>
          <div class="form-group">
            <!-- Activado Si/No -->
            <label for="enabled" class="font-weight-bold">Reglas activadas</label>
            <div>
              <toggle-switch
                @update="onEnabledUpdate"
                name="enabled"
                id="enabled"
                :checked="enabledIsChecked"
              />
            </div>
            <p>S&oacute;lo se tendr&aacute;n en cuenta las reglas especificadas en el SCR si est&aacute;n activadas.</p>
          </div>
          <div class="form-group">
            <!-- Descripcion/Notas -->
            <label for="description" class="font-weight-bold">Descripci&oacute;n o notas</label>
            <text-area
              @update="onDescriptionUpdate"
              name="description"
              id="description"
              rows="2"
              :value="rulesSet.description"
            />
          </div>
        </section>
        <!-- Reglas -->
        <section>
          <h2>Reglas</h2>
          <p>Se debe configurar al menos una regla. En el SCR se utilizar&aacute; el template especificado si se cumplen
            todas las reglas configuradas.</p>
          <div class="form-group">
            <!-- Tipo de compra -->
            <label for="purchase_main_type" class="font-weight-bold">Aplica a los siguientes tipos principales de
              compra</label>
            <purchase-main-type-selector
              @update="onPurchaseMainTypeUpdate"
              :selectedValues="selectedPurchaseMainTypes"
              id="purchase_main_type"
              name="purchase_main_type"
              placeholder="Selecciona tipos de compra"
            />
          </div>
          <div class="form-group">
            <!-- Tipo de dispositivo -->
            <label for="device_family" class="font-weight-bold">Aplica a los siguientes tipos de dispositivo</label>
            <div>
              <device-family-selector
                @update="onDeviceFamilyUpdate"
                :selectedValues="selectedDeviceFamilies"
                id='device_family'
                name='device_family'
                placeholder='Selecciona tipos de dispositivo'
              />
            </div>
          </div>
          <div class="form-group">
            <!-- Canal de venta -->
            <label for="channel" class="font-weight-bold">Aplica a los siguientes canales de venta</label>
            <div>
              <channel-selector
                @error="onComponentError"
                @update="onChannelUpdate"
                :selectedValues="selectedChannels"
                id='channel'
                name='channel'
                label="name"
                trackBy="id"
                placeholder='Selecciona canales de venta'
              />
            </div>
          </div>
          <div class="form-group">
            <!-- Marca -->
            <label for="brand" class="font-weight-bold">Aplica a las siguientes marcas</label>
            <div>
              <brand-selector
                @error="onComponentError"
                @update="onBrandUpdate"
                :selectedValues="selectedBrands"
                id='brand'
                name='brand'
                label="name"
                trackBy="id"
                placeholder='Selecciona marcas'
              />
            </div>
          </div>
          <div class="form-group">
            <!-- Campaña -->
            <label for="brand" class="font-weight-bold">Aplica a las siguientes campañas</label>
            <div>
              <campaign-selector
                @error="onComponentError"
                @update="onCampaignUpdate"
                :selectedValues="selectedCampaigns"
                id='campaign'
                name='campaign'
                label="name"
                trackBy="id"
                placeholder='Selecciona campañas'
              />
            </div>
          </div>
          <div class="form-group">
            <!-- B2B Checkbox Si/No -->
            <label for="b2b" class="font-weight-bold">Aplica si la compra es de B2B</label>
            <div>
              <toggle-switch
                @update="onB2BUpdate"
                name="b2b"
                id="b2b"
                :checked="B2BIsChecked"
              />
            </div>
          </div>
          <div class="form-group">
            <!-- Pais del cliente -->
            <label for="user_country" class="font-weight-bold">Aplica a los siguientes paises del cliente (según
              IP)</label>
            <div>
              <user-country-selector
                @error="onComponentError"
                @update="onUserCountryUpdate"
                :selectedValues="selectedUserCountry"
                id='user_country'
                name='user_country'
                label="name"
                trackBy="id"
                placeholder='Selecciona paises'
              />
            </div>
          </div>
          <div class="form-group">
            <!-- Compra relacionada Si/No -->
            <label for="related_purchase" class="font-weight-bold">Aplica si tiene una compra relacionada</label>
            <div>
              <toggle-switch
                @update="onRelatedPurchaseUpdate"
                name="related_purchase"
                id="related_purchase"
                :checked="relatedPurchaseIsChecked"
              />
            </div>
          </div>
          <div class="form-group">
            <!-- Gestor logado Si/No -->
            <label for="agent_logged_in" class="font-weight-bold">Aplica si hay un agente logado</label>
            <div>
              <toggle-switch
                @update="onAgentLoggedInUpdate"
                name="agent_logged_in"
                id="agent_logged_in"
                :checked="agentLoggedInIsChecked"
              />
            </div>
          </div>
          <div class="form-group">
            <!-- Ip permitida Si/No -->
            <label for="is_ip_allowed" class="font-weight-bold">Aplica sólo para ips internas</label>
            <div>
              <toggle-switch
                @update="onIsIpAllowedUpdate"
                name="is_ip_allowed"
                id="is_ip_allowed"
                :checked="isIpAllowedIsChecked"
              />
            </div>
          </div>
          <div class="form-group">
            <!-- Is Budget Si/No -->
            <label for="budget" class="font-weight-bold">Aplica si es una sesión de tipo "presupuesto"</label>
            <div>
              <toggle-switch
                @update="onIsBudgetUpdate"
                name="budget"
                id="budget"
                :checked="isBudget"
              />
            </div>
          </div>
          <div class="form-group">
            <!-- Cookie -->
            <label for="cookie" class="font-weight-bold">Aplica si se introduce la siguiente cookie</label>
            <div>
              <cookie-input
                @update="onCookieUpdate"
                :selectedValue="selectedCookie"
              />
            </div>
          </div>
          <div class="form-group">
            <!-- Remite -->
            <label for="remite" class="font-weight-bold">Aplica si se introduce el siguiente remite</label>
            <div>
              <remite-input
                @update="onRemiteUpdate"
                :selectedValue="selectedRemite"
              />
            </div>
          </div>
        </section>
        <div class="text-center">
          <button type="button" @click="sendData" class="btn btn-primary">Enviar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TemplateSelector from '@/components/Form/TemplateSelector.vue';
import ToggleSwitch from '@/components/Form/ToggleSwitch.vue';
import Textarea from '@/components/Form/Textarea.vue';
import PurchaseMainTypeSelector from '@/components/Form/PurchaseMainTypeSelector.vue';
import DeviceFamilySelector from '@/components/Form/DeviceFamilySelector.vue';
import ChannelSelector from '@/components/Form/ChannelSelector.vue';
import CookieInput from '@/components/Form/CookieInput.vue';
import RemiteInput from '@/components/Form/RemiteInput.vue';
import BrandSelector from '@/components/Form/BrandSelector.vue';
import UserCountrySelector from '@/components/Form/UserCountrySelector.vue';
import CampaignSelector from '@/components/Form/CampaignSelector.vue';
import RulesManager from '@/data-managers/RulesManager.js';
import RulesSetValidator from '@/validators/RulesSetValidator.js';

export default {
  name: 'rules-set',
  components: {
    'template-selector': TemplateSelector,
    'toggle-switch': ToggleSwitch,
    'text-area': Textarea,
    'purchase-main-type-selector': PurchaseMainTypeSelector,
    'device-family-selector': DeviceFamilySelector,
    'channel-selector': ChannelSelector,
    'cookie-input': CookieInput,
    'remite-input': RemiteInput,
    'brand-selector': BrandSelector,
    'user-country-selector': UserCountrySelector,
    'campaign-selector': CampaignSelector,
  },
  data() {
    return {
      rulesSet: {},
      errorMessages: [],
      successMessage: '',
    };
  },
  computed: {
    enabledIsChecked: function() {
      return this.rulesSet.enabled === '1';
    },
    B2BIsChecked: function() {
      return RulesManager.getBooleanRuleValue('is_b2b', this.rulesSet.rules);
    },
    relatedPurchaseIsChecked: function() {
      return RulesManager.getBooleanRuleValue('related_purchase_id', this.rulesSet.rules);
    },
    selectedPurchaseMainTypes: function() {
      return RulesManager.getRulePropertyValues('main_type', 'values', this.rulesSet.rules);
    },
    agentLoggedInIsChecked: function() {
      return RulesManager.getBooleanRuleValue('agent_logged_in', this.rulesSet.rules);
    },
    selectedDeviceFamilies: function() {
      return RulesManager.getRulePropertyValues('device_family', 'values', this.rulesSet.rules);
    },
    selectedChannels: function() {
      return RulesManager.getRulePropertyValues('channel', 'values', this.rulesSet.rules);
    },
    isIpAllowedIsChecked: function() {
      return RulesManager.getBooleanRuleValue('is_ip_allowed', this.rulesSet.rules);
    },
    selectedCookie: function() {
      let cookie = {};
      let values = RulesManager.getRulePropertyValues('cookie', 'values', this.rulesSet.rules);
      let parameters = RulesManager.getRulePropertyValues('cookie', 'parameters', this.rulesSet.rules);
      if (values && parameters) {
        cookie['name'] = parameters[0]['name'];
        cookie['value'] = values[0];
      }
      return cookie;
    },
    selectedRemite: function() {
      let values = RulesManager.getRulePropertyValues('remite_code', 'values', this.rulesSet.rules);
      if (values[0]) {
        return values[0];
      }
      return '';
    },
    selectedBrands: function() {
      return RulesManager.getRulePropertyValues('brand_id', 'values', this.rulesSet.rules);
    },
    selectedUserCountry: function() {
      return RulesManager.getRulePropertyValues('user_country_by_ip', 'values', this.rulesSet.rules);
    },
    selectedCampaigns: function() {
      return RulesManager.getRulePropertyValues('campaign_id', 'values', this.rulesSet.rules);
    },
    isBudget: function() {
      return RulesManager.getBooleanRuleValue('budget', this.rulesSet.rules);
    },
  },
  methods: {

    /********* Métodos asociados a eventos *********/

    onComponentError(message) {
      this.errorMessages.push(message);
    },
    onTemplateUpdate(value) {
      this.rulesSet.templateId = value;
    },
    onEnabledUpdate(value) {
      this.rulesSet.enabled = value ? '1' : '0';
    },
    onDescriptionUpdate(value) {
      this.rulesSet.description = value;
    },
    onPurchaseMainTypeUpdate(values) {
      this.rulesSet.rules = RulesManager.handleRule('main_type', 'in', values, null, this.rulesSet.rules);
    },
    onRelatedPurchaseUpdate(value) {
      this.rulesSet.rules = RulesManager.handleRule('related_purchase_id', 'equal', [value], null, this.rulesSet.rules);
    },
    onB2BUpdate(value) {
      this.rulesSet.rules = RulesManager.handleRule('is_b2b', 'equal', [value], null, this.rulesSet.rules);
    },
    onAgentLoggedInUpdate(value) {
      this.rulesSet.rules = RulesManager.handleRule('agent_logged_in', 'equal', [value], null, this.rulesSet.rules);
    },
    onDeviceFamilyUpdate(values) {
      this.rulesSet.rules = RulesManager.handleRule('device_family', 'in', values, null, this.rulesSet.rules);
    },
    onChannelUpdate(values) {
      this.rulesSet.rules = RulesManager.handleRule('channel', 'in', values, null, this.rulesSet.rules);
    },
    onIsIpAllowedUpdate(value) {
      this.rulesSet.rules = RulesManager.handleRule('is_ip_allowed', 'equal', [value], null, this.rulesSet.rules);
    },
    onCookieUpdate(value) {
      let cookieName = value['name'];
      let cookieValue = value['value'];
      this.rulesSet.rules = RulesManager.handleRule('cookie', 'equal', [cookieValue], [{'name': cookieName}], this.rulesSet.rules);
    },
    onRemiteUpdate(value) {
      this.rulesSet.rules = RulesManager.handleRule('remite_code', 'matches', [value], null, this.rulesSet.rules);
    },
    onBrandUpdate(values) {
      this.rulesSet.rules = RulesManager.handleRule('brand_id', 'in', values, null, this.rulesSet.rules);
    },
    onUserCountryUpdate(values) {
      this.rulesSet.rules = RulesManager.handleRule('user_country_by_ip', 'in', values, null, this.rulesSet.rules);
    },
    onCampaignUpdate(values) {
      this.rulesSet.rules = RulesManager.handleRule('campaign_id', 'in', values, null, this.rulesSet.rules);
    },
    onIsBudgetUpdate(value) {
      this.rulesSet.rules = RulesManager.handleRule('budget', 'equal', [value], null, this.rulesSet.rules);
    },

    /******************** Misc **********************/

    sendData() {
      if (this.validateRulesSet()) {
        if (this.rulesSet.id) {
          this.updateRuleSet();
        } else {
          this.createRuleSet();
        }
      }
      this.scrollToTop();
    },

    validateRulesSet() {
      this.successMessage = '';
      this.errorMessages = RulesSetValidator.validate(this.rulesSet);
      return this.errorMessages.length === 0;
    },

    scrollToTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    },

    /************ Métodos de gestión de los datos de las reglas **************************/

    initRuleSet() {
      if (this.$route.name === 'editRulesSet') {
        fetch('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_templates_api_rest/RulesSet/index?id=' + this.$route.params.id)
          .then(response => response.json())
          .then(data => {
            if (data.result) {
              this.rulesSet = data.data;
            } else {
              this.errorMessages.push('Se ha producido un error al consultar las reglas.');
            }
          }).catch(() => {
          this.errorMessages.push('Se ha producido un error al consultar las reglas.');
        });
      } else {
        this.rulesSet = {
          'id': '',
          'rules': JSON.stringify({'rules': []}),
          'description': '',
          'templateId': '',
          'enabled': '0',
        };
      }
    },
    createRuleSet() {
      fetch('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_templates_api_rest/RulesSet/index', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.rulesSet),
      }).then(response => response.json())
        .then(data => {
        if (data.result) {
          this.rulesSet = data.data;
          this.successMessage = 'Reglas creadas correctamente';
        } else {
          this.errorMessages.push('Se ha producido un error al crear las reglas.');
        }
      }).catch(() => {
        this.errorMessages.push('Se ha producido un error al crear las reglas.');
      });
    },
    updateRuleSet() {
      fetch('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_templates_api_rest/RulesSet/index', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.rulesSet),
      }).then(response => response.json())
        .then(data => {
        if (data.result) {
          this.successMessage = 'Reglas actualizadas correctamente';
        } else {
          this.errorMessages.push('Se ha producido un error al actualizar las reglas.');
        }
      }).catch(() => {
        this.errorMessages.push('Se ha producido un error al actualizar las reglas.');
      });
    },
  },

  /***********************************************************/

  mounted() {
    this.initRuleSet();
  },
};
</script>
